import { OfferStatus, UserData } from '../types';

export const defaultUser: UserData = {
  id: '',
  appointmentId: '',
  user: '',
  fullName: '',
  position: '',
  organizationalUnitName: '',
  employmentContract: '',
  managerName: '',
  managerPosition: '',
  workSchedule: '',
  workFormat: '',
  location: '',
  paidAnnualLeave: '',
  equipmentProvided: '',
  salary: '',
  salaryIncluding: '',
  annualBonus: '',
  semiAnnualBonus: '',
  quarterlyBonus: '',
  monthlyBonus: '',
  projectAward: '',
  pieceBonus: '',
  allowance: '',
  mainTasks: '',
  action: '',
  actionEnds: '',
  recruiterName: '',
  recruiterTelephone: '',
  recruiterEmail: '',
  startWorkDate: '',
  status: OfferStatus.new,
  businessUnit: {
    id: '',
    businessUnit: '',
    vk: '',
    telegram: '',
    dzen: '',
    habr: '',
    newx5: '',
  },
  benefits: [
    {
      title: 'Медицинская страховка',
      items: [
        'Подключение к ДМС в соответствии с корпоративной политикой',
        'Оплата больничных',
        'Материальная помощь сотрудникам попавшим в сложную жизненную ситуацию (после прохождения испытательного срока)',
      ],
      benefit_key: 'MedInsurance',
    },
    {
      title: 'Корпоративная жизнь',
      items: [
        'Масштабные и яркие праздники',
        'Чемпионаты по киберспорту',
        'Открытые встречи с топ-менеджментом',
        'Благотворительные и экологические программы',
        'Митапы для обмена опытом',
        'Корпоративное предпринимательство',
        'Внутренние комьюнити экспертов',
      ],
      benefit_key: 'CorporateLife',
    },
    {
      title: 'Обучение и развитие',
      items: [
        'Курсы и образовательные программы в Цифровой академии X5',
        'Дистанционные курсы на открытых образовательных платформах',
        'Корпоративная онлайн-библиотека',
        'Мастер-классы по системе Fast Track Learning',
        'Программы развития управленческих навыков всех уровней',
      ],
      benefit_key: 'Education',
    },
    {
      title: 'Дополнительные бонусы',
      items: [
        'Программа привилегий PrimeZone (6000+ спецпредложений)',
        'Скидки в экосистеме бизнесов X5 ("Пятёрочка", "Перекрёсток", "Много лосося", "5post")',
      ],
      benefit_key: 'Bonus',
    },
  ],
};
